import { FETCH_PRODUCT_DETAIL_FAILURE_RESPONSE, FETCH_PRODUCT_DETAIL_SUCCESS_RESPONSE,
    UPLOAD_MANUL_SECTION_DATA_RESPONSE, DOWNLOAD_MANUL_SECTION_DATA_TEMPLATE_RESPONSE,
    DOWNLOAD_QUICK_REPORT_CASE_SUMMARY_RESPONSE, DOWNLOAD_QUICK_REPORT_CASE_CREATION_TEMPLATE_RESPONSE,
    DOWNLOAD_QUICK_REPORT_CASE_STATUS_FILE_RESPONSE, DOWNLOAD_QUICK_REPORT_CASE_CRAWLER_STATUS_FILE_RESPONSE,
    INITIATE_OR_STOP_QUICK_CRAWLERS_RESPONSE  } from './action';

const initialState = {
}

const quickReportCaseReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PRODUCT_DETAIL_FAILURE_RESPONSE:
            return {
                ...state,
                productFailure: action.data
            }

        case FETCH_PRODUCT_DETAIL_SUCCESS_RESPONSE:
            return {
                ...state,
                productSuccess: action.data
            }

        case UPLOAD_MANUL_SECTION_DATA_RESPONSE:
            return {
                ...state,
                uploadData: action.data
            }

        case DOWNLOAD_MANUL_SECTION_DATA_TEMPLATE_RESPONSE:

            return {
                ...state,
                downloadManualSection: { templateData: action.data.data, status: action.data.status }
            }

        case DOWNLOAD_QUICK_REPORT_CASE_SUMMARY_RESPONSE :
            return {
                ...state,
                summaryData : { summary : action.data.data, status : action.data.status }
            }
        
        case DOWNLOAD_QUICK_REPORT_CASE_CREATION_TEMPLATE_RESPONSE :
            return {
                ...state,
                quickReportCreationTemplate : { quickReportCreationTemplate  : action.data.data, status : action.data.status }
            }

        case DOWNLOAD_QUICK_REPORT_CASE_STATUS_FILE_RESPONSE :
            return {
                ...state,
                quickReportStatus : { statusFile : action.data.data, status : action.data.status}
            }

        case DOWNLOAD_QUICK_REPORT_CASE_CRAWLER_STATUS_FILE_RESPONSE : 
            return {
                ...state,
                crawlerStatus :  { statusFile : action.data.data, status : action.data.status}
            }

        case INITIATE_OR_STOP_QUICK_CRAWLERS_RESPONSE:
            return {
                ...state,
                quickCrawlerResponse: action.data
            }
        default: return state
    }

};

export default quickReportCaseReducer;
